import apiClient from '../client';
const ENDPOINT = '/teachers';

export const teachersApi = {
    getList: ({ page = 1, pageSize = 10, sortBy = '-id', filter = {} }) =>
        apiClient.get(ENDPOINT, { params: { page, pageSize, sortBy, filter } }),
    getDetail: (id) => apiClient.get(`${ENDPOINT}/${id}`),
    create: (payload) => apiClient.post(`${ENDPOINT}`, payload),
    update: (payload) => apiClient.put(`${ENDPOINT}/${payload.id}`, payload),
    delete: (id, payload) => apiClient.delete(`${ENDPOINT}/${id}?teacherId=${payload?.teacherId}`)
};
